<template>
  <table class="info-table table table-sm">
    <tr>
      <th class="border-top-0">{{$t('Attribute')}}</th>
      <th class="border-top-0">{{$t('Old')}}</th>
      <th class="border-top-0">{{$t('New')}}</th>
    </tr>
    <tr>
      <td>{{$t('Premiums')}}</td>
      <td v-html="oldPremiums()"></td>
      <td v-html="newPremiums()"></td>
    </tr>
  </table>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";

  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "ActivityPremiumsTable",
    props: {
      activity: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...globalMapState(['currentBranch']),
    },
    methods: {
      oldPremiums() {
        if (!this.activity.old_data || !this.activity.old_data.premiums) {
          return '';
        }
        return this.getPremiumsHtml(this.activity.old_data.premiums);
      },
      newPremiums() {
        if (!this.activity.data || !this.activity.data.premiums) {
          return '';
        }
        return this.getPremiumsHtml(this.activity.data.premiums);
      },
      getPremiumsHtml(premiums) {
        let returnValue = '';
        premiums.forEach((premium) => {
          returnValue += this.$i18n.t('Percentage: {percentageVal}% | Over: {overAmount}{currencySymbol}', {
            percentageVal: premium.percent,
            overAmount: premium.amount_over,
            currencySymbol: this.currentBranch.currency.symbol,
          }) + "<br>";
        });
        return returnValue;
      }
    }
  }
</script>

<style scoped>

</style>
